import type { IntlShape } from "react-intl";
import type { FavoriteDomain } from "@/graphql/generated/operations";

// The grammatical gender of what a list counts (der Film, die Serie, das
// Gericht), for the texts that speak of one of them: "Fehlt einer?", "Keins
// davon". It belongs to the language, not to the code, so each bundle names it
// per domain under grow.games.toplist.genus.<DOMAIN>. "other" covers a language
// without genders and a list of mixed things, such as artists and bands.
export type Genus = "m" | "f" | "n" | "other";

export function listGenus(intl: IntlShape, domain: FavoriteDomain): Genus {
  const id = `grow.games.toplist.genus.${domain}`;
  const value = id in intl.messages ? intl.formatMessage({ id }) : "other";
  return value === "m" || value === "f" || value === "n" ? value : "other";
}
